import type { AlbumInput } from '../domain/entities/Album.entity';
import type { GalleryItemInput } from '../domain/entities/GalleryItem.entity';

/**
 * The 7 real album categories provided directly by the client (Daruosh) on
 * 2026-08-10, replacing the earlier 2 invented placeholder albums.
 *
 * `galleryItemsContent` is intentionally EMPTY — per explicit client
 * instruction, no fake images and no stock photos standing in as real
 * company photos. Each album's `coverImage` points at a shared placeholder
 * graphic (not a fabricated photo) so the page still renders sensibly with
 * zero real content. Real photos get added per-album once available; this
 * static array is the interim stand-in for the "add via Admin" workflow the
 * client asked for — Gallery does not yet have an admin CRUD screen (unlike
 * `scientific-content`, see features/admin), which is the natural next
 * phase once real photos exist to justify building it.
 */
export const albumsContent: AlbumInput[] = [
  {
    id: 'album-mines',
    title: 'معادن',
    slug: 'mines',
    coverImage: '/images/gallery/placeholder-album-cover.svg'
  },
  {
    id: 'album-exploration-areas',
    title: 'محدوده‌های اکتشافی',
    slug: 'exploration-areas',
    coverImage: '/images/gallery/placeholder-album-cover.svg'
  },
  {
    id: 'album-exploration-operations',
    title: 'عملیات اکتشاف',
    slug: 'exploration-operations',
    coverImage: '/images/gallery/placeholder-album-cover.svg'
  },
  {
    id: 'album-mining-operations',
    title: 'عملیات معدنی',
    slug: 'mining-operations',
    coverImage: '/images/gallery/placeholder-album-cover.svg'
  },
  {
    id: 'album-equipment-machinery',
    title: 'تجهیزات و ماشین‌آلات',
    slug: 'equipment-machinery',
    coverImage: '/images/gallery/placeholder-album-cover.svg'
  },
  {
    id: 'album-industrial-projects',
    title: 'پروژه‌های صنعتی',
    slug: 'industrial-projects',
    coverImage: '/images/gallery/placeholder-album-cover.svg'
  },
  {
    id: 'album-field-visits',
    title: 'بازدیدهای میدانی',
    slug: 'field-visits',
    coverImage: '/images/gallery/placeholder-album-cover.svg'
  }
];

export const galleryItemsContent: GalleryItemInput[] = [];
